/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type MascheraDispositivo =
  (typeof MascheraDispositivo)[keyof typeof MascheraDispositivo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MascheraDispositivo = {
  GFL_TFL_700: "GFL_TFL_700",
  GFL_MONITORING_WTP: "GFL_MONITORING_WTP",
  GFL_MONITORING_WT: "GFL_MONITORING_WT",
  GFL_SENSOR_WT: "GFL_SENSOR_WT",
  PRAEVIDERE_GRADUS_35: "PRAEVIDERE_GRADUS_35",
  PRAEVIDERE_VIBRATIO_35: "PRAEVIDERE_VIBRATIO_35",
  GFL_DFA_3500: "GFL_DFA_3500",
  GFL_TLV_300: "GFL_TLV_300",
  GFL_MONITORING_EM: "GFL_MONITORING_EM",
  NEXUS_6D: "NEXUS_6D",
} as const;
